import { ref, computed } from 'vue';
import ajax from '@/utils/Ajax';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useNotification } from '@shared/components/ui/notification';
import { useRegisterStore } from '@/stores/RegisterStore';

export function useVerConnectFunction() {
  const store = useGlobalStore();
  const registerStore = useRegisterStore();
  const { openNotBottom } = useNotification();
  const proofDialogValue = ref({
    open: false, //true,
  });

  const connectCheck = async (item, key) => {
    let more_soc = window.localStorage.getItem('CREATOR_PROTAL_is_more_social');
    let is_verifity = window.localStorage.getItem('CREATOR_PROTAL_is_verifity');
    try {
      store.loading = true;
      const res = await ajax.post('/connect-social-account', { cache_key: key });
      const data = res.data.data;
      const isNewConnect = data.is_new_connect;
      //串聯的social發現綁在其他帳號，要請使用者證明其他帳號也是他的
      const isOtherAccount = data.need_verify_motom ? data.verify_motom_code : false; //true; //

      const connectSuccess = async () => {
        if (is_verifity) {
          await registerStore.handleVerSocialPage();
        } else {
          await registerStore.spGetUserHandle();
        }
      };

      if (isOtherAccount) {
        window.localStorage.setItem('CREATOR_PROTAL_verify_motom_code', isOtherAccount);
        proofDialogValue.value = {
          open: true,
        };
      }
      //有串聯過的不要繼續做畫面，但帳號本來就是連著的，一樣要往下走
      else if (!isNewConnect) {
        openNotBottom(`This account is already connected`, 'error');
        setTimeout(() => {
          connectSuccess();
        }, 1000);
      }
      //同個平台多串一個帳號顯示文字
      else if (window.localStorage.getItem('CREATOR_PROTAL_new_add_social')) {
        openNotBottom(`New social account added`, 'success');

        setTimeout(async () => {
          connectSuccess();
        }, 1000);
      }
      //正常第一次串
      else {
        openNotBottom(`${item} connection successful`, 'success');
        //me這隻API要存social需要一陣子,所以從API回傳放資料
        //store.user.social_accounts.push(res.data.data);
        setTimeout(async () => {
          connectSuccess();
        }, 1000);
      }

      window.localStorage.removeItem('CREATOR_PROTAL_new_add_social');
      window.localStorage.removeItem('CREATOR_PROTAL_is_more_social');
      window.localStorage.removeItem('CREATOR_PROTAL_is_verifity');
    } catch (error) {
      //tmep fake data for development
      // openNotBottom(`${item} connection successful`, 'success');
      // if (is_verifity) {
      //   await registerStore.handleVerSocialPage();
      // } else {
      //   await registerStore.spGetUserHandle();
      // }
      // window.localStorage.removeItem('CREATOR_PROTAL_new_add_social');
      // window.localStorage.removeItem('CREATOR_PROTAL_is_more_social');
      // window.localStorage.removeItem('CREATOR_PROTAL_is_verifity');
      // return;

      const errorMessage = error?.response?.data?.data?.message || '';
      openNotBottom(`${item} connection not successful${errorMessage ? `, ${errorMessage}` : ''}`, 'error');
      window.localStorage.removeItem('CREATOR_PROTAL_new_add_social');
      window.localStorage.removeItem('CREATOR_PROTAL_is_more_social');
      window.localStorage.removeItem('CREATOR_PROTAL_is_verifity');
      if (is_verifity) {
        await registerStore.handleRegisterSocial();
        registerStore.step = '3-1';
      } else if (more_soc) {
        await registerStore.spGetUserHandle();
        registerStore.step = '3-2';
      }
      registerStore.loading = false;
      store.loading = false;
    } finally {
      store.loading = false;
    }
  };

  const findConnect = async () => {
    try {
      let ig = JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_ig_social_key'));
      let tk = JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_tk_social_key'));
      let yt = JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_yt_social_key'));
      //找到ig資訊
      if (ig) {
        window.localStorage.removeItem('CREATOR_PROTAL_ig_social_key');
        connectCheck('Instagram', ig);
      }
      //找到tk資訊
      else if (tk) {
        window.localStorage.removeItem('CREATOR_PROTAL_tk_social_key');
        connectCheck('TikTok', tk);
      }
      //找到yt資訊
      else if (yt) {
        window.localStorage.removeItem('CREATOR_PROTAL_yt_social_key');
        connectCheck('YouTube', yt);
      }
    } catch (error) {}
  };

  const findBindConnect = async () => {
    let verify_motom_code = window.localStorage.getItem('CREATOR_PROTAL_verify_motom_code');
    let cache_key = window.localStorage.getItem('CREATOR_PROTAL_login_cache_key');

    if (verify_motom_code) {
      store.loading = true;
      try {
        let formData = new FormData();

        formData.append('verify_motom_code', verify_motom_code);
        formData.append('cache_key', cache_key);
        const res = await ajax.post('/bind-motom-account', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        let getdata = res.data.data;

        //me這隻API要存social需要一陣子,所以從API回傳放資料
        setTimeout(async () => {
          await registerStore.handleVerSocialPage();
        }, 1000);
        openNotBottom(`Binding account success.`, 'success');
      } catch (error) {
        if (error?.response?.data?.data?.message) {
          openNotBottom(`${error.response.data.data.message}`, 'error');
        } else {
          openNotBottom(`Binding account fail`, 'error');
        }
      } finally {
        store.loading = false;
        window.localStorage.removeItem('CREATOR_PROTAL_verify_motom_code');
        window.localStorage.removeItem('CREATOR_PROTAL_login_cache_key');
      }
    }
  };

  return {
    connectCheck,
    findConnect,
    proofDialogValue,
    findBindConnect,
  };
}
